/**
 *  Elementor hacks
 */

// Make sure accordions is closed by default
jQuery(document).ready(function($) {
  setTimeout(function() {
    $('.elementor-tab-title').removeClass('elementor-active');
    $('.elementor-tab-content').css('display', 'none');


  }, 100);

});
